module.exports = __webpack_public_path__ + "static/media/Ulol.4a07fd64.png";